import { forwardRef, useEffect, useState } from 'react';
import { AllieInput } from '../Input/Input';
import { AllieTimeInputProps } from './TimeInput.types';

export const AllieTimeInput = forwardRef(
  (
    {
      allieType = 'primary',
      corner = 'rounded',
      allieSize = 'small',
      disabled = false,
      shadow = false,
      onChange,
      onIonChange,
      value,
      errorMessage,
      icon,
      suffix,
      onClick,
      ...props
    }: AllieTimeInputProps,
    ref
  ) => {
    // Función para formatear el valor de tiempo
    const formatTimeValue = (val: string): string => {
      if (!val) return '';
      // Mantener solo números
      const numericValue = val.replace(/[^0-9]/g, '');
      
      // Aplicar formato de hh:mm
      if (numericValue.length <= 2) {
        return numericValue;
      } else if (numericValue.length <= 4) {
        return `${numericValue.slice(0, 2)}:${numericValue.slice(2)}`;
      } else {
        return `${numericValue.slice(0, 2)}:${numericValue.slice(2, 4)}`;
      }
    };

    const [inputValue, setInputValue] = useState<string>(
      formatTimeValue(value as string)
    );

    useEffect(() => {
      setInputValue(formatTimeValue(value as string));
    }, [value]);

    const handleInputChange = (e: CustomEvent) => {
      const rawValue = e.detail.value;
      
      // Si está vacío, permitir
      if (!rawValue) {
        setInputValue('');
        if (onIonChange) {
          onIonChange(e);
        }
        return;
      }

      // Mantener solo números y aplicar formato
      const formattedValue = formatTimeValue(rawValue);
      
      // Validación básica para hora y minutos
      const parts = formattedValue.split(':');
      const hours = parseInt(parts[0] || '0', 10);
      const minutes = parseInt(parts[1] || '0', 10);
      
      // Solo actualizar si los valores son válidos
      if (hours <= 23 && (parts.length < 2 || minutes <= 59)) {
        setInputValue(formattedValue);
        
        // Crear un evento personalizado para mantener la compatibilidad
        if (onIonChange) {
          const customEvent = new CustomEvent('ionChange', {
            detail: { value: formattedValue }
          });
          onIonChange(customEvent);
        }
      }
    };

    return (
      <AllieInput
        type="text"
        inputmode="numeric"
        allieType={allieType}
        corner={corner}
        allieSize={allieSize}
        disabled={disabled}
        shadow={shadow}
        errorMessage={errorMessage}
        icon={icon}
        suffix={suffix}
        onClick={onClick}
        onIonChange={handleInputChange}
        value={inputValue}
        placeholder="00:00"
        maxlength={5}
        ref={ref}
        {...props}
      />
    );
  }
); 